import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';

const PillButton = styled(Link)`
  background-color: ${({ $isWhite }) => ($isWhite ? "black" : "white")};  
  color: ${({ $isWhite }) => ($isWhite ? "white" : "black")};  
  text-decoration: none;
  text-transform: uppercase;
  text-align: center;
  padding: 24px 66px;
  border-radius: 70px;
  position: relative;
  width: max-content;
  font-size: 17px;
 
  @media (max-width: ${({ theme }) => `${theme.breakpoints[1]}px`}) {    
    font-size: 14px;
    padding: 19px 52px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colours.green};
    color: ${({ theme }) => theme.colours.black};
  }
}
`;

function ButtonLink({ isWhite, label, url }) {
  return (
    <PillButton $isWhite={isWhite} to={url}>
      {label}
    </PillButton>
  );
}

export default ButtonLink;
